import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject, ref } from 'vue';
import rules from '@/app/shared/domain/data/rules';
import CnpjSearchService from '../../application/services/CnpjSearchService';
import useNotificationRepository from '@/app/shared/infrastructure/persistence/notification-repository';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCnpj',
  props: ['modelValue', 'label'],
  emits: ['update:modelValue', 'cnpjDataFound'],
  setup(__props, { emit }) {

const props = __props;

const cnpjSearchService = inject('cnpjSearchService') as CnpjSearchService;



const loading = ref(false);

function searchCnpjData() {
    let cnpj = new String(props.modelValue);
    cnpj = cnpj.replaceAll('/', '');
    cnpj = cnpj.replaceAll('.', '');
    cnpj = cnpj.replaceAll('-', '');

    if (cnpj.length != 14) {
        useNotificationRepository().insert({
            id: Date.now().toString(),
            type: 'warning',
            message: 'Insira um CNPJ válido para o preenchimento automático.'
        });
        return;
    }

    loading.value = true;

    cnpjSearchService.get(cnpj.toString()).then(cnpjData => {
        console.log('cnpjDataFound on inputCnpj', cnpjData);
        emit('cnpjDataFound', cnpjData);
    }).catch(error => {
        useNotificationRepository().insert({
            id: Date.now().toString(),
            type: 'error',
            message: 'Não foi possível encontrar os dados do CNPJ.'
        });
        console.warn('search cnpj error on inputCnpj', error);
    }).finally(() => loading.value = false);
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _directive_mask = _resolveDirective("mask")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_text_field, {
    rules: [_unref(rules).required, _unref(rules).cnpj],
    label: __props.label,
    "model-value": __props.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:modelValue', value)),
    "append-inner-icon": "mdi:mdi-search-web",
    "onClick:appendInner": searchCnpjData,
    loading: loading.value
  }, null, 8, ["rules", "label", "model-value", "loading"])), [
    [_directive_mask, '##.###.###/####-##']
  ])
}
}

})